<template lang="pug">
  v-form(class="change-name py-8")
    h2(class="mb-6") {{ $t('Change full name') }}
    ValidationObserver(ref="changeNameForm")
      t-orm-fields(:fullName.sync="fullName" :items="fields")
    v-btn(
      class="main-button w-100"
      :loading="loading"
      @click="submit"
      ) {{ $t('Change') }}
</template>

<script>
import TOrmFields from '~/components/templates/orm/t-orm-fields'
import User from '~/models/administration/User'

export default {
  name: 'MFormChangeName',
  components: {
    TOrmFields
  },
  props: {
    currentName: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    fullName: '',
    loading: false
  }),
  computed: {
    fields () {
      return [
        {
          model: 'fullName',
          component: 'v-text-field',
          provider: {
            name: 'Full name',
            vid: 'firstName',
            rules: 'required|min:3',
            mode: 'lazy'
          },
          attrs: {
            label: 'Enter full name',
            outlined: true,
            required: true
          },
          classes: ['app-filled-input']
        }
      ]
    }
  },
  created () {
    this.fullName = this.currentName
  },
  methods: {
    async submit () {
      const valid = await this.$refs.changeNameForm.validate()

      if (valid) {
        try {
          this.loading = true
          await User.api().updateUserProfile({ name: this.fullName })
          this.$attrs.closeModal(true, true)
        } catch (e) {
          this.$handlers.error(e, this)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.change-name {
  color: $dark;
}
</style>
